import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components";
import { fetchTenantsByFeatureFlag } from '../app/actions';
import { FormControl, FormGroup, Table } from "react-bootstrap";
import { debounce } from 'throttle-debounce';

const Card = styled.div`
box-shadow: 0px 1px 4px #c5c5c5;
-webkit-box-shadow: 0px 1px 4px #c5c5c5;
-moz-box-shadow: 0px 1px 4px #c5c5c5;
margin-bottom: 1em;
border-radius: 4px;
background: white;
`
const CardHeader = styled.div`
padding: 20px 16px;
font-size: 1.2em;
background-color: #f1f1f1;
color: #303030;
display: flex;
justify-content: space-between;
`

function FeatureFlagTenantsList({ featureId }) {

    const dispatch = useDispatch();
    const fetchingTenants = useSelector(store => store.app.fetchingTenants)
    const tenants = useSelector(store => store.app.tenants)
    const [filter, setFilter] = useState({ search: "", type: "" })
    const throttledSearch = useCallback(debounce(500, (search, type) => {
        dispatch(fetchTenantsByFeatureFlag(featureId, search, type))
    }), [])

    useEffect(()=>{
        dispatch(fetchTenantsByFeatureFlag(featureId, filter.search, filter.type))
    }, [])

    const handleChangeFilter = (e) => {

        let newFilter = {...filter, [e.target.name]: e.target.value}
        throttledSearch(newFilter.search, newFilter.type)
        setFilter(newFilter)
    }

  return (
    <Card>
        <CardHeader>Tenants ({tenants && tenants.length})</CardHeader>
        <div style={{ display: "flex" }}>
            <FormGroup style={{ margin: "5px 5px 10px 10px" }}>
                <label>
                    Search
                </label>
                <FormControl value={filter.search} onChange={handleChangeFilter} name="search">
                </FormControl>
            </FormGroup>
            <FormGroup style={{ margin: "5px 5px 10px 10px" }}>
                <label>
                    Type
                </label>
                <FormControl custom as="select" value={filter.type} onChange={handleChangeFilter} name="type">
                    <option value="">All</option>
                    <option value="Internal">Internal</option>
                    <option value="Partner">Partner</option>
                    <option value="Prospect">Prospect</option>
                    <option value="Paying Customer">Paying Customer</option>
                </FormControl>
            </FormGroup>
        </div>
        {!fetchingTenants && <Table striped bordered hover style={{width: "100%"}}>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Full Name</th>
                    <th>Short Name</th>
                    <th>DB_NAME</th>
                    <th>DB_HOST</th>
                    <th>Active</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Comment</th>
                    <th>Updated</th>
                    <th>Created</th>
                </tr>
            </thead>
            <tbody>
                {tenants && tenants.map(tenant => {

                    return (
                        <tr key={tenant.id}>
                            <td>{tenant.id}</td>
                            <td>{tenant.FullName}</td>
                            <td>{tenant.ShortName}</td>
                            <td>{tenant.DB_NAME}</td>
                            <td>{tenant.DB_HOST}</td>
                            <td>{tenant.Active}</td>
                            <td>{tenant.Type}</td>
                            <td>{tenant.BusinessStatus}</td>
                            <td>{tenant.BusinessComment}</td>
                            <td>{tenant.updated_at}</td>
                            <td>{tenant.created_at}</td>
                        </tr>
                    )
                })}
            </tbody>
        </Table>}
    </Card>
  )
}

export default FeatureFlagTenantsList
